/* eslint-disable react/jsx-no-target-blank */
/* eslint-disable react/style-prop-object */
import React from 'react'
import elevaTech from "../Image/projectImages/elevateTech_portfolio_project.jpg";
import bathKit from "../Image/projectImages/bathKit_portfolio_project.jpg";
import vastra from "../Image/projectImages/vastra_portfolio_proect.jpg";
import iskra from "../Image/projectImages/iskra_portfolio_project.jpg";
import loveBeauty from "../Image/projectImages/loveliBeauty_portfolio_project.jpg";
import mg from "../Image/projectImages/2mg_portfolio_project.jpg";
import styledComp from "../Image/styled_compo.png";
import firebase from "../Image/firebase.png";
import js from "../Image/js.png"
import html from "../Image/html.png"
import css from "../Image/css.png"
import react from "../Image/reactl.png"
import redux from "../Image/redux.png"
import chakra from "../Image/chakra-ui.png"


export const Projects = () => {
    return (
        <section id="projects">
            <div className="heading">
                <h2>Projects</h2>
                <span>Some Works Of Mine❤</span>
            </div>

            <div className="projects-container">

                <div className="project-card">
                    <img src={bathKit} alt="pepperfry" />
                    <div className="project-name">
                        <h3 className="project-title">Bath Kit</h3>
                    </div>
                    <div className="project-description">
                        <p>An e-commerce app for bathroom and kitchen utensils, ensuring customer satisfaction by delivering genuine, high-quality products. </p>
                    </div>
                    <h4>Tech Stack</h4>
                    <div className="project-tech-stack1">
                        <div className="tech-card">
                            <img src={html} alt="html" />
                            <h6 className="project-tech-stack">HTML</h6>
                        </div>
                        <div className="tech-card">
                            <img src={css} alt="css" />
                            <h6 className="project-tech-stack">CSS</h6>
                        </div>
                        <div className="tech-card">
                            <img src={js} alt="js" />
                            <h6 className="project-tech-stack">JS</h6>
                        </div>
                    </div>

                    <div className="projects-button">
                        <button className="button-project-link"> <a className="project-deployed-link"
                            href=" https://dancing-frangollo-fd368f.netlify.app/" target="_blank">Live</a></button>
                        <button className="button-project-link"><a className="project-github-link"
                            href="https://github.com/WDwithSuraj/bed-bathandbeyond-clone" target="_blank">GitHub</a></button>
                    </div>
                </div>


                <div className="project-card">
                    <img src={loveBeauty} alt="dell.com" />
                    <div className="project-name">
                        <h3 className="project-title">Sugar Clone</h3>
                    </div>
                    <div className="project-description">
                        <p>Discover Your Beauty with Sugar: Reliable Beauty Products Carefully Chosen for Unmatched Quality and a Confident, Radiant You. </p>
                    </div>

                    <h4>Tech Stack</h4>
                    <div className="project-tech-stack1">
                        <div className="tech-card">
                            <img src={html} alt="html" />
                            <h6 className="project-tech-stack">HTML</h6>
                        </div>
                        <div className="tech-card">
                            <img src={css} alt="css" />
                            <h6 className="project-tech-stack">CSS</h6>
                        </div>
                        <div className="tech-card">
                            <img src={js} alt="js" />
                            <h6 className="project-tech-stack">JS</h6>
                        </div>
                    </div>
                    <div className="projects-button">
                        <button className="button-project-link"> <a className="project-deployed-link"
                            href="https://startling-liger-821b48.netlify.app/" target="_blank">Live</a></button>
                        <button className="button-project-link"><a className="project-github-link"
                            href="https://github.com/WDwithSuraj/sugar_cosmetic_clone" target="_blank">GitHub</a></button>
                    </div>
                </div>

                <div className="project-card">
                    <img src={iskra} alt="" />
                    <div className="project-name">
                        <h3 className="project-title">Meesho Clone</h3>
                    </div>
                    <div className="project-description">
                        <p>Experience Affordable Elegance with Iskra: Discover Timeless Clothing of Exceptional Quality, Boosting Your Confidence.</p>
                    </div>
                    <h4>Tech Stack</h4>
                    <div className="project-tech-stack1">
                        <div className="tech-card">
                            <img src={html} alt="html" />
                            <h6 className="project-tech-stack">HTML</h6>
                        </div>
                        <div className="tech-card">
                            <img src={css} alt="css" />
                            <h6 className="project-tech-stack">CSS</h6>
                        </div>
                        <div className="tech-card">
                            <img src={js} alt="js" />
                            <h6 className="project-tech-stack">JS</h6>
                        </div>
                    </div>

                    <div className="projects-button">
                        <button className="button-project-link"> <a className="project-deployed-link"
                            href="https://iridescent-syrniki-cb0de0.netlify.app/" target="_blank">Live</a></button>
                        <button className="button-project-link"><a className="project-github-link"
                            href="https://github.com/WDwithSuraj/fancy-thunder-426" target="_blank">GitHub</a></button>
                    </div>
                </div>

                <div className="project-card">
                    <img src={elevaTech} alt="elevate tech home page" />
                    <div className="project-name">
                        <h3 className="project-title">ElevaTech</h3>
                    </div>
                    <div className="project-description">
                        <p>ElevaTech is an e-commerce platform that offers a wide range of technology products, including laptops, desktops, mobile, headphone,  and accessories.</p>
                    </div>

                    <h4>Tech Stack</h4>
                    <div className="project-tech-stack1">
                        <div className="tech-card">
                            <img src={react} alt="react" />
                            <h6 className="project-tech-stack">React</h6>
                        </div>
                        <div className="tech-card">
                            <img src={redux} alt="redux" />
                            <h6 className="project-tech-stack">Redux</h6>
                        </div>
                        <div className="tech-card">
                            <img src={firebase} alt="redux" />
                            <h6 className="project-tech-stack">Firebase</h6>
                        </div>
                        <div className="tech-card">
                            <img src={styledComp} alt="redux" />
                            <h6 className="project-tech-stack">Styled</h6>
                        </div>
                    </div>
                    <div className="projects-button">
                        <button className="button-project-link"> <a className="project-deployed-link"
                            href="https://monumental-cassata-92e164.netlify.app/" target="_blank">Live</a></button>
                        <button className="button-project-link"><a className="project-github-link"
                            href="https://github.com/WDwithSuraj/Elevatech_Codebase" target="_blank">GitHub</a></button>
                    </div>
                </div>


                <div className="project-card">
                    <img src={vastra} alt="zee5" />
                    <div className="project-name">
                        <h3 className="project-title">Vastra</h3>
                    </div>
                    <div className="project-description">
                        <p>Vastra: Embrace elegance with our exclusive luxury fashion range. Meticulously crafted for uncompromising quality and timeless style.  </p>
                    </div>
                    <h4>Tech Stack</h4>
                    <div className="project-tech-stack1">
                        <div className="tech-card">
                            <img src={react} alt="react" />
                            <h6 className="project-tech-stack">React.js</h6>
                        </div>



                        <div className="tech-card">
                            <img src={redux} alt="redux" />
                            <h6 className="project-tech-stack">Redux</h6>
                        </div>
                        <div className="tech-card">
                            <img src={chakra} alt="css" />
                            <h6 className="project-tech-stack">Chakra UI</h6>
                        </div>
                    </div>

                    <div className="projects-button">
                        <button className="button-project-link"> <a className="project-deployed-link"
                            href="https://vastra-delta.vercel.app/" target="_blank">Live</a></button>
                        <button className="button-project-link"> <a className="project-github-link"
                            href="https://github.com/WDwithSuraj/bloomingdale-s-clone" target="_blank">GitHub</a></button>
                    </div>
                </div>



                <div className="project-card">
                    <img src={mg} alt="pepperfry" />
                    <div className="project-name">
                        <h3 className="project-title">2mg | Pharma</h3>
                    </div>
                    <div className="project-description">
                        <p>2MG: Elevate Your Health with Our Trusted Medicines and Expert Doctor Consultancy. Meticulously Curated for Uncompromising Quality and a Healthy, Happy Life. </p>
                    </div>
                    <h4>Tech Stack</h4>
                    <div className="project-tech-stack1">
                        <div className="tech-card">
                            <img src={react} alt="react" />
                            <h6 className="project-tech-stack">React</h6>
                        </div>
                        <div className="tech-card">
                            <img src={css} alt="css" />
                            <h6 className="project-tech-stack">Css</h6>
                        </div>
                        <div className="tech-card">
                            <img src={redux} alt="redux" />
                            <h6 className="project-tech-stack">Redux</h6>
                        </div>
                        <div className="tech-card">
                            <img src="https://w7.pngwing.com/pngs/129/910/png-transparent-api-text-application-programming-interface-computer-icons-web-api-computer-programming-thumbnail.png" alt="css" />
                            <h6 className="project-tech-stack">API</h6>
                        </div>
                    </div>

                    <div className="projects-button">
                        <button className="button-project-link"> <a className="project-deployed-link"
                            href="https://grand-conkies-b7c025.netlify.app/" target="_blank">Live</a></button>
                        <button className="button-project-link"><a className="project-github-link"
                            href="https://github.com/WDwithSuraj/tan-shock-2774" target="_blank">GitHub</a></button>
                    </div>
                </div>





            </div>
            {/* <!-- <br /><br />
          <p style="text-align: center; margin-top: 8px; color:rgb(2, 166, 70); ;">Made with ❤ By Suraj Yadav</p> --> */}

        </section>

    )
}
